module.exports = __webpack_public_path__ + "img/banner1.56150e0d.jpg";